import { Injectable } from '@angular/core';

import {
  ControlValidator,
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError
} from '../../types/validator.types';

@Injectable()
export class StringLengthControlValidator extends ControlValidator {
  type = ControlValidatorType.StringLength;
  validateMoment = ControlValidateMoment.Input;

  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');

    let value = this.control.model.value;
    if (typeof value === 'number') {
      value = value.toString();
    }
    // valueå¼ä¸ºç©ºæ¶ï¼ä¸æ ¡éª
    if (!value && value !== 0) {
      this.error = new ControlValidatorError(true, '');
      return this.error;
    }

    const max = parseInt(this.model.max, 10);
    let min = parseInt(this.model.min, 10);

    if (isNaN(min)) {
      min = 0;
    }
    let message = 'è¯·å¡«å' + min + '-' + max + 'ä¸ªå­ç¬¦';
    if (isNaN(max)) {
      message = 'è¯·å¡«åè³å°' + min + 'ä¸ªå­ç¬¦';
    }
    if (min === max) {
      message = 'è¯·å¡«å' + min + 'ä¸ªå­ç¬¦';
    }

    const valid = this.isValid(value, min, max);
    if (!valid) {
      this.error.message = message;
      this.error.success = false;
    } else {
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }

  private isValid(value: string, min: number, max: number): boolean {
    // å¼æ¯ç©º å¦æmin===0 åéè¿
    if (!value && min === 0) {
      return true;
    }
    if (value) {
      const valueLength = value.length;
      if (isNaN(max)) {
        if (min <= valueLength) {
          return true;
        }
      } else if (min <= valueLength && valueLength <= max) {
        return true;
      }
    }
    return false;
  }
}
